import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

//React component that represents an optional icon,a required link and a button via buttonAction and buttonText
const LinkList = ({ itemList, isCard }) => {
  const classList = classNames({
    box: isCard,
  });

  const listItem = ({ linkIcon, linkText, linkHref }, index) => (
    <li key={`${index}${linkText}`}>
      {linkIcon && (
        <span className="icon">
          <i className={linkIcon}></i>
        </span>
      )}
      <a className="has-text-weight-bold" href={linkHref}>
        {linkText}
      </a>
    </li>
  );

  return (
    <div className={classList}>
      <ul>{itemList.map((item, index) => listItem(item, index))}</ul>
    </div>
  );
};

LinkList.propTypes = {
  itemList: PropTypes.arrayOf(
    PropTypes.shape({
      linkIcon: PropTypes.string,
      linkText: PropTypes.string.isRequired,
      linkHref: PropTypes.string.isRequired,
    }).isRequired
  ),
  isCard: PropTypes.bool,
};

LinkList.defaultProps = {
  isCard: false,
};

export default LinkList;
